module.exports = __webpack_public_path__ + "img/c-class-sedan.2f3392e3.jpg";